export default function initBrandsOverview(): void {
  Alpine.data("brandsOverview", () => ({
    activeLetter: null as string | null,
    stickyBarOffset: 0,
    letters: [] as HTMLElement[],
    letterSections: [] as HTMLElement[],
    init() {
      this.letters = Array.from(document.querySelectorAll('[data-brand-letter]'));
      this.letterSections = Array.from(document.querySelectorAll('[data-brand-section]'));
      this.handleScroll = this.handleScroll.bind(this);
      window.addEventListener('scroll', this.handleScroll);
      this.handleScroll();
    },
    handleScroll() {
      let active: string | null = null;
      let closestSection: HTMLElement | null = null;
      let closestTop = -Infinity;
      this.letterSections.forEach(section => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= 120 && rect.top > closestTop) {
          closestTop = rect.top;
          closestSection = section;
        }
      });
      if (closestSection !== null) {
        active = (closestSection as HTMLElement).dataset.brandSection || null;
      } else if (this.letterSections.length) {
        const firstRect = this.letterSections[0].getBoundingClientRect();
        const lastRect = this.letterSections[this.letterSections.length - 1].getBoundingClientRect();
        if (firstRect.top > 120) {
          active = this.letterSections[0].dataset.brandSection || null;
        } else if (lastRect.top <= 120) {
          active = this.letterSections[this.letterSections.length - 1].dataset.brandSection || null;
        }
      }
      this.activeLetter = active;
      this.stickyBarOffset = this.$root.getBoundingClientRect().top;
    },
    scrollToLetter(letter: string) {
      const section = this.letterSections.find(s => s.dataset.brandSection === letter);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }));
}
